const sensorClassificationUnit = {
  energy: 'kW',
  temperature: '°C',
  humidity: '%',
  kwh_limit: 'kWh',
  
};

export default sensorClassificationUnit;
